import { createContext, useState } from 'react';

const useValue = () => {
    const [showLogin, setShowLogin] = useState(true);

    return {
        showLogin,
        setShowLogin,
    };
};

const TokenContext = createContext({} as ReturnType<typeof useValue>);

const TokenProvider = ({ children }: any) => {
    return <TokenContext.Provider value={useValue()}>{children}</TokenContext.Provider>;
};

export { TokenProvider, TokenContext };
